export const DEFAULT_FONT_SIZE = 14;
export const FONT_FAMILIES = ['Work Sans'];
export const FONT_WEIGHTS = [200, 400, 600];
export const DEFAULT_FONT_UNIT = 1;
export const FONT_SIZES = [0.8, 0.9, 1, 1.2, 1.3, 1.4, 1.5];
